require("magnific-popup");

module.exports = {
  init: () => {
    $(".gallery-item").magnificPopup({
      type: "image",
      gallery: {
        enabled: true
      }
    });
  }
};
